import { render } from "./ImportHistoryDialog.vue?vue&type=template&id=02d99d4c"
import script from "./ImportHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./ImportHistoryDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script